import React from 'react';
import './DecorativeCircle.css';
import {useAppContext} from "../../context/AppState/AppContext";

function DecorativeCircle(props) {
    const {size, opacity, shadow = 1, top, left, right, bottom, hideInMobile} = props;
    const { isMobile } = useAppContext()
    const style = {
        width: `${size}px`,
        height: `${size}px`,
        borderWidth: `${size}px`,
        opacity: opacity,
    };

    if (top !== undefined) {
        style.top = `${top}px`;
    }

    if (left !== undefined) {
        style.left = `${left}px`;
    }

    if (right !== undefined) {
        style.right = `${right}px`;
    }

    if (bottom !== undefined) {
        style.bottom = `${bottom}px`;
    }

    if (hideInMobile !== undefined && isMobile) {
        style.display = `none`;
    }

    return (
        <div
            className={`decorativeCircle decorativeCircle__shadow-${shadow}`}
            style={style}
        ></div>
    );
}

export default DecorativeCircle;